"use client";
import { createContext, useContext } from "react";

const PortIdentity = createContext({ name: "Port de Premià", slug: "portdepremia" });
export const PortIdentityProvider = PortIdentity.Provider;
export const usePortIdentity = () => useContext(PortIdentity);
